import type {Recipe} from './types';

export const paccheriCremaBurrataGuanciale: Recipe = {
    id: 3,
    key: "paccheriCremaBurrataGuanciale",
    pictures: [
        {index: 0, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/DSC_4588.jpg"},
        {index: 1, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_1.jpg"},
        {index: 2, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_2.jpg"},
        {index: 3, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_5.jpg"},
        {index: 4, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_7.jpg"},
        {index: 5, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/DSC_0603.jpg"},
        {index: 6, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_9.jpg"},
        {index: 7, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_12.jpg"},
        {index: 8, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/Paccheri_crema_di_burata_e_pistacchi_13.jpg"},
        {index: 9, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2020/10/DSC_4794-1.jpg"},
    ],
    i18n: {
        IT: {
            title: "Paccheri con guanciale, crema di burrata e pistacchi",
            servings: "Per 4 persone",
            ingredients: [
                "PACCHERI 320 gr",
                "GUANCIALE 150 gr",
                "BURRATA 300 gr",
                "PISTACCHI SGUSCIATI 50 gr",
                "SALE q.b",
                "PEPE q.b",
            ],
            steps: [
                "Tagliate il guanciale a listerelle sottili",
                "Raccogliete i pistacchi in un mixer da cucina e tritateli fino a ottenere una granella sottile. Levate e tenete da parte.",
                "Tagliate a tocchetti la burrata, raccoglieteli nel mixer, tenendone da parte qualcuno per la guarnizione finale, e frullate fino a ottenere un composto cremoso. Aggiungete un po' di granella di pistacchi e amalgamate ancora.",
                "In una padella antiaderente ben calda mettete il guanciale e fatelo rosolare per bene.",
                "Aiutandovi con una schiumarola, prelevate il guanciale, facendo attenzione a lasciare il grasso di cottura all'interno della padella, e mettete da parte.",
                "Lessate la pasta in acqua bollente e salata, quindi scolatela al dente, versatela in padella e mantecate per bene a fiamma vivace.",
                "Aggiungete la crema di burrata e poi il guanciale quindi lasciate insaporire per bene (se necessario, unite un goccio di acqua di cottura della pasta).",
                "Completate con una spolverizzata di granella di pistacchi tenuta da parte.",
                "Impiattate, decorate con qualche fiocchetto di burrata fresca e servite.",
            ],
            notes: "Potete sostituire il guanciale con dello speck; se invece volete realizzare una versione vegetariana della ricetta, potete eliminare il salume e aggiungere dei pomodorini secchi, rinvenuti in acqua tiepida per qualche minuto, e poi tagliati a tocchetti piccoli.\nPotete sostituire i paccheri lisci con quelli rigati oppure con un altro formato di pasta corta a vostro piacere, come i rigatoni o le mezze maniche.",
        },
        EN: {
            title: "Paccheri with Guanciale, Burrata Cream, and Pistachios",
            servings: "For 4 people",
            ingredients: [
                "PACCHERI 320 gr",
                "GUANCIALE 150 gr",
                "BURRATA 300 gr",
                "SHELLED PISTACHIOS 50 gr",
                "SALT to taste",
                "PEPPER to taste",
            ],
            steps: [
                "Cut the guanciale into thin strips.",
                "Place the pistachios in a food processor and chop them until you obtain a fine grain. Set aside.",
                "Cut the burrata into small pieces, place them in the food processor (set aside a few pieces for garnish), and blend until you get a creamy mixture. Add some of the pistachio grains and blend again.",
                "In a well-heated non-stick pan, add the guanciale and brown it well.",
                "Using a slotted spoon, remove the guanciale, being careful to leave the cooking fat in the pan, and set it aside.",
                "Boil the pasta in salted water, then drain it al dente, pour it into the pan, and mix well over high heat.",
                "Add the burrata cream and then the guanciale. Let it all mix well (if necessary, add a little pasta cooking water).",
                "Finish by sprinkling with the remaining pistachio grains.",
                "Plate, decorate with a few dollops of fresh burrata, and serve.",
            ],
            notes: "You can replace guanciale with speck; for a vegetarian version, omit the cured meat and add sun-dried tomatoes, soaked in warm water for a few minutes, then cut into small pieces.\nYou can replace smooth paccheri with ridged ones or another short pasta shape, such as rigatoni or mezze maniche.",
        },
        PL: {
            title: "Paccheri z guanciale, kremem z burraty i pistacjami",
            servings: "Dla 4 osób",
            ingredients: [
                "PACCHERI 320 g",
                "GUANCIALE 150 g",
                "BURRATA 300 g",
                "ŁUSKANE PISTACJE 50 g",
                "SÓL do smaku",
                "PIEPRZ do smaku",
            ],
            steps: [
                "Pokrój guanciale na cienkie paski.",
                "Umieść pistacje w mikserze kuchennym i posiekaj je na drobną kruszonkę. Odłóż na bok.",
                "Pokrój burratę na małe kawałki, umieść je w mikserze (odłóż kilka kawałków na końcową dekorację) i miksuj, aż uzyskasz kremową konsystencję. Dodaj trochę kruszonki z pistacji i ponownie wymieszaj.",
                "Na dobrze rozgrzaną, nieprzywierającą patelnię wrzuć guanciale i smaż, aż się dobrze zrumieni.",
                "Za pomocą łyżki cedzakowej wyjmij guanciale, starając się pozostawić tłuszcz z gotowania na patelni, i odłóż na bok.",
                "Ugotuj makaron w osolonej wodzie, następnie odcedź go al dente, przełóż na patelnię i dobrze wymieszaj na dużym ogniu.",
                "Dodaj krem z burraty, a następnie guanciale, i pozwól, aby wszystkie smaki się połączyły (jeśli to konieczne, dodaj odrobinę wody z gotowania makaronu).",
                "Na koniec posyp pozostałą kruszonką pistacjową.",
                "Wyłóż na talerze, udekoruj kilkoma kawałkami świeżej burraty i podawaj.",
            ],
            notes: "Możesz zastąpić guanciale speckiem; dla wersji wegetariańskiej, pomiń wędliny i dodaj suszone pomidory, które namocz przez kilka minut w ciepłej wodzie, a następnie pokrój na małe kawałki.\nMożesz zastąpić gładkie paccheri wersją żłobioną lub innym krótkim makaronem, takim jak rigatoni czy mezze maniche.",
        },
    },
};
